export const CREATE_PAYMENT_START='CREATE_PAYMENT_START';
export const CREATE_PAYMENT_SUCCESS='CREATE_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_FAIL='CREATE_PAYMENT_FAIL';

export const GET_PAYMENT_START='GET_PAYMENT_START';
export const GET_PAYMENT_SUCCESS='GET_PAYMENT_SUCCESS';
export const GET_PAYMENT_FAIL='GET_PAYMENT_FAIL';

export const TOGGLE_ADD_PAYMENT_MODAL='TOGGLE_ADD_PAYMENT_MODAL';